export const initialAuthState = {
    status: 'init',
    errors: [],
    task: null,
    session: null,
    permissions: null,
    isAuthenticated: false,
    isInitialized: false,
    loginMethod: null,
    lastActivity: 0,
    sessionTimeout: 0,
    loginAttempts: 0,
    lockoutUntil: null,
    redirectUrl: null,
    twoFactorRequired: false,
    twoFactorToken: null,
    devToken: null
};
export var AUTH_ACTIONS;
(function (AUTH_ACTIONS) {
    AUTH_ACTIONS["SET_AUTH_STATUS"] = "SET_AUTH_STATUS";
    AUTH_ACTIONS["SET_AUTH_ERRORS"] = "SET_AUTH_ERRORS";
    AUTH_ACTIONS["SET_AUTH_TASK"] = "SET_AUTH_TASK";
    AUTH_ACTIONS["SET_AUTH_SESSION"] = "SET_AUTH_SESSION";
    AUTH_ACTIONS["SET_AUTH_AUTHENTICATED"] = "SET_AUTH_AUTHENTICATED";
    AUTH_ACTIONS["SET_AUTH_INITIALIZED"] = "SET_AUTH_INITIALIZED";
    AUTH_ACTIONS["SET_AUTH_LOGIN_METHOD"] = "SET_AUTH_LOGIN_METHOD";
    AUTH_ACTIONS["SET_AUTH_LAST_ACTIVITY"] = "SET_AUTH_LAST_ACTIVITY";
    AUTH_ACTIONS["SET_AUTH_SESSION_TIMEOUT"] = "SET_AUTH_SESSION_TIMEOUT";
    AUTH_ACTIONS["INCREMENT_AUTH_LOGIN_ATTEMPTS"] = "INCREMENT_AUTH_LOGIN_ATTEMPTS";
    AUTH_ACTIONS["CLEAR_AUTH_LOGIN_ATTEMPTS"] = "CLEAR_AUTH_LOGIN_ATTEMPTS";
    AUTH_ACTIONS["SET_AUTH_LOCKOUT_UNTIL"] = "SET_AUTH_LOCKOUT_UNTIL";
    AUTH_ACTIONS["SET_AUTH_REDIRECT_URL"] = "SET_AUTH_REDIRECT_URL";
    AUTH_ACTIONS["SET_AUTH_TWO_FACTOR_REQUIRED"] = "SET_AUTH_TWO_FACTOR_REQUIRED";
    AUTH_ACTIONS["SET_AUTH_TWO_FACTOR_TOKEN"] = "SET_AUTH_TWO_FACTOR_TOKEN";
    AUTH_ACTIONS["SET_AUTH_PERMISSIONS"] = "SET_AUTH_PERMISSIONS";
    AUTH_ACTIONS["SET_AUTH_DEV_TOKEN"] = "SET_AUTH_DEV_TOKEN";
    AUTH_ACTIONS["LOGOUT"] = "LOGOUT";
})(AUTH_ACTIONS || (AUTH_ACTIONS = {}));
